import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ITicketSector, IXId } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { IAirSector } from 'libraries/service/resources/model/search/air/IAirSector';
import { BookingTravellerTicketService } from '../booking-information/components/booking-traveller-card/components/booking-traveller/components/booking-traveller-ticket/services/booking-traveller-ticket.service';
import { faArrowRight, IconDefinition, faEllipsisH, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import {wenji} from "../../interfaces/IWenji";

@Component({
    selector: 'sectors-air-simple-list',
    template: `
<!--        <div [innerHTML]="sectorList"></div>-->
        <div class="info-container">
            <ng-container *ngFor="let sector of sectors; let i = index; let f = first">
                <ng-container *ngIf="sector">
                    <ng-container *ngIf="f">
                        <div class="alignElements verticalAlignTop">
                            <span>{{sector.from.airport.code || sector.from.airport.iata}}</span>
                            <span *ngIf="showBeginEndTime" class="blockAligned">{{sector.begin.value | dateMoment:timeFormat }}</span>
                        </div>
                        <div class="alignElements">
                            <fa-icon [icon]="iconRight" size="xs"></fa-icon>
                        </div>
                        <div class="alignElements verticalAlignTop">
                            <span>{{sector.to.airport.code || sector.to.airport.iata}}</span>
                            <span *ngIf="showBeginEndTime" class="blockAligned">{{sector.end.value | dateMoment:timeFormat }}</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!f && sectors && (sector.from.airport.code || sector.from.airport.iata) === (sectors[i - 1]?.to.airport.code || sectors[i - 1]?.to.airport.iata)">
                        <fa-icon [icon]="iconRight" size="xs"></fa-icon> {{sector.to.airport.code || sector.to.airport.iata}}
                    </ng-container>
                    <ng-container *ngIf="!f && sectors && (sector.from.airport.code || sector.from.airport.iata) !== (sectors[i - 1]?.to.airport.code || sectors[i - 1]?.to.airport.iata)">
                        <fa-icon [icon]="iconEllipsis" ></fa-icon> {{sector.from.airport.code || sector.from.airport.iata}}
                        <fa-icon [icon]="iconRight" size="xs"></fa-icon> {{sector.to.airport.code || sector.from.airport.iata}}
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    `,
    styles: [`
        .alignElements {
            display: inline-block;
        }
        
        .verticalAlignTop {
            vertical-align: top;
        }
        
        .blockAligned {
            display: block;
            font-weight: 400;
        }
    `]
})

export class SectorsAirSimpleListComponent {
    @Input()
    public sectors: ITicketSector[];
    @Input()
    public fareComponentSectors: IXId[];
    @Input()
    public showBeginEndTime: boolean = false;

    public iconRight: IconDefinition = faArrowRight;
    public iconEllipsis: IconDefinition = faEllipsisH;
    public readonly timeFormat: string = JSON.parse(wenji.ui.dateFormat).momentTime;
}
